import React from "react";
import { Box, Grid, Button } from "@mui/material";

import { SuccessProbabilityMeter } from "./shared/SuccessProbabilityMeter";
import { filterContentOnScore, probBarContent } from "./shared/Content";
import { matchPathname } from "../Utils";
import { includeQueryParams, nextStepsURLs, SECURE_URL } from "./shared/Links";

const Content = ({
  confidenceScoreResult,
  isAuthenticated,
  showMeter,
  lowerLimit,
  upperLimit
}) => {
  console.log("isAuthenticated", isAuthenticated);
  const contentText = filterContentOnScore(
    probBarContent,
    confidenceScoreResult,
    lowerLimit,
    upperLimit
  );
  const guestUerHeaderText = `We put clients at the center of everything we do. Let us help you plan and save for your financial future.`;
  const guestUerSubText = `Remember to log in or sign up to access more helpful tools and resources.`;

  return (
    <Box sx={{ display: "flex " }} className="beacon-theme-modern-outlook">
      <Grid
        container
        className="b-container"
        sx={{
          paddingBottom: "32px",
          inlineSize: "unset !important",
        }}
      >
        <Grid
          item
          size={{
            xs: 12,
            sm: isAuthenticated ? 9 : 12,
          }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box display="flex" alignItems="end">
            <Box
              sx={{
                verticalAlign: "center",
                paddingTop: "32px",
                paddingBottom: { md: "32px", xs: "16px" },
              }}
              className="b-typography-serif--headline-loose--300"
              id="success-probability-bar-header-text"
            >
              {isAuthenticated ? contentText.text || null : guestUerHeaderText}
            </Box>
          </Box>
          {!isAuthenticated && (
            <div>
              <Box
                sx={{
                  verticalAlign: "center",
                  paddingBottom: { sm: "16px", xs: "32px" },
                }}
                className="b-typography-sans-serif--body-loose--200"
                id="success-probability-bar-sub-text"
              >
                {guestUerSubText}
              </Box>
              <Button
                disableRipple
                sx={{
                  color: "white",
                  background: "#0063AD",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  boxShadow: "none",
                  marginRight: "20px",
                  "&:hover": {
                    backgroundColor: "#006485",
                    color: "white",
                    textDecoration: "none",
                  },
                  width: { xs: "100%", sm: "inherit" },
                }}
                onClick={() => {
                  window.location.replace(includeQueryParams(SECURE_URL));
                }}
                variant="contained"
                id="login-signup"
              >
                Log In or Sign Up
              </Button>
            </div>
          )}
        </Grid>
        {isAuthenticated && showMeter ? (
          <Grid item size={{ xs: 12, sm: 3 }}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <SuccessProbabilityMeter
                min={lowerLimit}
                max={upperLimit}
                confidenceScoreResult={confidenceScoreResult}
              />
            </Box>
          </Grid>
        ) : (
          ""
        )}
      </Grid>
    </Box>
  );
};

const SuccessProbabilityBar = ({
  confidenceScoreResult,
  isAuthenticated,
  showMeter,
  lowerLimit,
  upperLimit
}) => {
  if (matchPathname(nextStepsURLs).length) {
    return (
      <Box
        display="flex"
        sx={{ background: "#F4F5F6" }}
        id="success-probability-bar"
        className="beacon-theme-modern-outlook"
      >
        <Box>
          <Content
            confidenceScoreResult={confidenceScoreResult}
            isAuthenticated={isAuthenticated}
            showMeter={showMeter}
            lowerLimit={lowerLimit}
            upperLimit={upperLimit}
          />
        </Box>
      </Box>
    );
  }
  return <div />;
};

export default SuccessProbabilityBar;
